var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetCategoryElasticResults, Vendd.ElasticSearch, function (envelope) {       

        var orderOptions = "_score:desc";

		var options = {
			url: "../engine/esqueryindex",
			data: {
				type: "categories",
				query: envelope.message.data.searchTerm,
				pagefrom: envelope.message.data.pageFrom,
				pagesize: envelope.message.data.pageSize,
				sort: orderOptions,
				path: "?hidefromsearch=1"
			},
            onSuccess: onSuccess,
            onFailure: onFailure
		};

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetCategoryElasticResultsSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetCategoryElasticResultsFailed(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetProductElasticResults, Vendd.ElasticSearch, function (envelope) {

        var orderOptions = envelope.message.data.sortingKey + ':' + envelope.message.data.orderType;

		var options = {
			url: "../engine/esqueryindex",
			data: {
				type: "products",
				query: envelope.message.data.searchTerm,
				pagefrom: envelope.message.data.pageFrom,
				pagesize: envelope.message.data.pageSize,
				sort: orderOptions,
				path: "?hidefromsearch=1"
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};



        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetProductElasticResultsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetProductElasticResultsFailed(response));
        }

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});